<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import Link from "svelte-link";
  import { Image } from "sveltestrap";
  import {Message} from "../../Data/Layout/Header";
  import { href } from "../../utils/Constant/Constant";
  let imgPath : string= '/assets/images/user';
</script>

<li class="onhover-dropdown">
  <FeatherIcon icon="message-square" />
  <ul class="chat-dropdown onhover-show-div">
    {#each Message as messageItem}
      <li>
        <div class="media">
          <Image
            fluid
            class="rounded-circle me-3"
            src={`${imgPath}/${messageItem.src}`}
            alt=""
          />
          <div class="media-body">
            <span>{messageItem.Name}</span>
            <p class="f-12 light-font">{messageItem.Detail}</p>
          </div>
          <p class="f-12">{messageItem.Time}</p>
        </div>
      </li>
    {/each}
    <li class="text-center">
      <Link class="f-w-700" href={href}>See All</Link>
    </li>
  </ul>
</li>
